import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { toastNotifySuccess } from '@/components/Common/Toast';
import {
  getWishlistItemCountByUser,
  setItemWishlistState,
} from '@/redux/actions/wishlist';
import { ITEM_WISHLIST_STATE } from 'src/constants/wishlist';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/reducers';
import { toggleGlobalAuthModal } from 'src/redux/actions';

interface customToastType {
  msg: string;
}
interface UseSetWishlistStateResult {
  setWishlistState: (payload: any, callback?: any, showCustomToast?: customToastType) => void;
}

export function useSetWishlistState(): UseSetWishlistStateResult {
  const dispatch = useDispatch();
  const { storeData, userData, isLogin } = useSelector((state: RootState) => ({
    storeData: state.storeReducer?.store,
    userData: state.userReducer?.data,
    isLogin: state.userReducer?.isLogin,
  }));

  const setWishlistState = useCallback((payload, callback, showCustomToast=null) => {
    if (!isLogin && payload?.status !== ITEM_WISHLIST_STATE.ADD_TO_CART) {
      dispatch(toggleGlobalAuthModal(true));
      callback(false);
      return;
    }
    payload = {
      ...payload,
      user_id: userData?.user_id,
      user_phone: userData?.phone,
      store_id: storeData?.store_id,
      user_email: userData?.email,
    };

    dispatch(
      setItemWishlistState(payload, (status: boolean) => {
        if (status) {
          payload?.status !== ITEM_WISHLIST_STATE.ADD_TO_CART ?
            toastNotifySuccess(
              payload?.status === ITEM_WISHLIST_STATE.ITEM_WISHLISTED
                ? 'Item added to wishlist'
                : 'Item removed from wishlist'
            ) : showCustomToast &&
            toastNotifySuccess(`${showCustomToast?.msg || 'Wishlist updated'}`);
          dispatch(getWishlistItemCountByUser({ store_id: storeData?.store_id }));
          callback(true);
        }
      })
    );
  }, [isLogin, storeData]);

  return { setWishlistState };
}
